import { create } from 'zustand';
import { conditionalDevtools } from '@/lib/storeMiddleware';

export interface DraftEventData {
  summary?: string;
  date?: string;
  startMinutes?: number | null;
  endMinutes?: number | null;
  allDay?: boolean;
}

interface CalendarModalState {
  createDialogOpen: boolean;
  draftCalendarUid: string | null;
  draftEventData: DraftEventData | null;
  editingEventId: string | null;
  openCreateDialog: (calendarUid?: string | null) => void;
  openCreateDialogWithDraft: (calendarUid: string | null, draftData: DraftEventData) => void;
  closeCreateDialog: () => void;
  editEvent: (eventId: string | null) => void;
  setDraftCalendar: (calendarUid: string | null) => void;
}

export const useCalendarModalStore = create<CalendarModalState>()(
  conditionalDevtools(
    (set) => ({
      createDialogOpen: false,
      draftCalendarUid: null,
      draftEventData: null,
      editingEventId: null,
      openCreateDialog: (calendarUid) => set({ createDialogOpen: true, draftCalendarUid: calendarUid ?? null, draftEventData: null, editingEventId: null }),
      openCreateDialogWithDraft: (calendarUid, draftData) => set({ createDialogOpen: true, draftCalendarUid: calendarUid, draftEventData: draftData, editingEventId: null }),
      closeCreateDialog: () => set({ createDialogOpen: false, draftCalendarUid: null, draftEventData: null, editingEventId: null }),
      editEvent: (eventId) => set({ editingEventId: eventId, createDialogOpen: true, draftEventData: null }),
      setDraftCalendar: (calendarUid) => set({ draftCalendarUid: calendarUid }),
    }),
    { name: 'CalendarModalStore' }
  )
);
